import { render } from "./products.vue?vue&type=template&id=73207e76&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"

import "./products.vue?vue&type=style&index=0&id=73207e76&scoped=true&lang=css"
import "./products.vue?vue&type=style&index=1&id=73207e76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73207e76"]])

export default __exports__